export const signInLandings = {
  requestAccessCode: {
      value: 'REQUEST_ACCESS_CODE',
      name: {
          id: `oe.website.requestingAccessCode`,
          description: 'Label text',
          defaultMessage: 'Requesting Access Code',
      },
  },
  haveAccessCode: {
      value: 'HAVE_ACCESS_CODE',
      name: {
          id: `oe.website.havingAccessCode`,
          description: 'Label text',
          defaultMessage: 'Having Access Code',
      },
  }
};

export const accessCodeStatus = {
  randomlyGenerated: {
      value: 'RANDOMLY_GENERATED',
      name: {
          id: `oe.website.randomlyGenerated`,
          description: 'Label text',
          defaultMessage: 'Randomly Generated',
      },
  },
  predefined: {
      value: 'PREDEFINED',
      name: {
          id: `oe.website.predefined`,
          description: 'Label text',
          defaultMessage: 'Predefined',
      },
  }
};

export const timeZoneDisplayTypeLabels = {
  default: {
      value: 'DEFAULT_GMT',
      name: {
          id: `oe.website.defaultGmt`,
          description: 'Label text',
          defaultMessage: 'Default: GMT +X:XX',
      },
  },
  offsetWithGeography: {
      value: 'OFFSET_WITH_GEOGRAPHY',
      name:  {
          id: `oe.website.offsetWithGeography`,
          description: 'Label text',
          defaultMessage: 'Offset with geography',
      },
  },
  custom: {
      value: 'CUSTOM',
      name: {
          id: `oe.website.customTimeZone`,
          description: 'Label text',
          defaultMessage: 'Custom time zone label',
      },
  }
};

export const CONFIGURE_PASSPORT_TITLE_INFO_TEXT = {
    id: 'oe.passportSettings.configurePassportTitleInfoText',
    defaultMessage: 'The Event Title is the name of the Event which attendees will see on all Passport pages.',
    description: 'Label text'
};

export const CONFIGURE_PASSPORT_PUBLIC_DESCRIPTION_INFO_TEXT = {
    id: 'oe.passportSettings.configurePassportPublicDescriptionInfoText',
    defaultMessage: 'The Event Public Description is displayed on the Registration and Sign In pages.',
    description: 'Label text'
};

export const CONFIGURE_PASSPORT_PRIVATE_DESCRIPTION_INFO_TEXT = {
    id: 'oe.passportSettings.configurePassportPrivateDescriptionInfoText',
    defaultMessage: 'The Event Private Description is displayed on the Welcome tab for attendees who have registered or signed in.',
    description: 'Label text'
};

export const CONFIGURE_PASSPORT_THUMBNAIL_INFO_TEXT = {
    id: 'oe.passportSettings.configurePassportThumbnailInfoText',
    defaultMessage: 'The Event Thumbnail is the image attendees will see on the Event card if this event is made available via an Event Hub.',
    description: 'Label text'
};

export const calendarInvitesOptions = {
    downloadCalendarFiles: {
        value: 'DOWNLOAD_CALENDAR_FILES',
        name: {
            id: `oe.website.downloadCalendarFiles`,
            description: 'Label text',
            defaultMessage: 'Download Calendar Files',
        },
    },
    subscribeToCalendar: {
        value: 'SUBSCRIBE_TO_CALENDAR',
        name: {
            id: `oe.website.subscribeToCalendar`,
            description: 'Label text',
            defaultMessage: 'Subscribe to Calendar',
        },
    },
    both: {
        value: 'BOTH',
        name: {
            id: `oe.website.both`,
            description: 'Label text',
            defaultMessage: 'Both',
        },
    },
  };
